module.exports = __webpack_public_path__ + "media/images/icons/google_chrome_logo-d172db6b8aa23e474972c2d31034a156.svg";